'use client'

import { Container, Typography } from '@mui/material'

import { useTranslations } from '@/hooks/useTranslations'

interface Props {
  debugInfo?: {
    tenantId: string
    headers: Array<[string, string]>
  }
}

export const NotFoundClient = ({ debugInfo }: Props) => {
  const { translate } = useTranslations()

  return (
    <Container sx={{ my: 4 }}>
      <Typography variant="h1" gutterBottom>
        {translate('page.404.title')}
      </Typography>
      {debugInfo != null && (
        <Container sx={{ mt: 3, p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
          <Typography variant="subtitle1" gutterBottom>
            Debug information
          </Typography>
          <Typography variant="body2">Tenant: {debugInfo.tenantId}</Typography>
          {debugInfo.headers.length > 0 && (
            <Container sx={{ mt: 2, p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
              <Typography variant="subtitle2" gutterBottom>
                Request headers
              </Typography>
              {debugInfo.headers.map(([key, value], index) => (
                <Typography variant="body2" key={`${key}-${index}`}>
                  {key}: {value}
                </Typography>
              ))}
            </Container>
          )}
        </Container>
      )}
    </Container>
  )
}
